import * as xss from 'xss';
import _ from 'lodash';

const whiteListObj = {
  script: [],
}; //can use later

let options = {
  css: false,
  whiteList: whiteListObj,
}; // Custom rules

let myxss = new xss.FilterXSS(options);

/*eslint-disable*/
const jsBaseList = [
  'javascript:',
  '&lt;script&gt;',
  '&lt;/script&gt;',
  'document.execCommand',
  'alert\\(',
];
/*eslint-enable*/

const jsEventsList = ['onError', 'onClick', 'onFocus']; // can update later eg: ["onClick=", "onFocus"]

const blackList = jsEventsList.concat(jsBaseList);

const cleanObj = (obj) => {
  for (const k in obj) {
    try {
      let val = obj[k];
      if (typeof val === 'string') {
        if (/<\/?[a-z][\s\S]*>/i.test(val)) {
          val = myxss.process(val);
        }
        val = cleanStrRecursively(val);
        obj[k] = val;
      } else {
        val = cleanObj(val);
      }
    } catch (e) {
      console.error(e);
    }
  }
  return obj;
};

const sanitizeString = (msgStr) => {
  msgStr = myxss.process(msgStr);
  return cleanStrRecursively(msgStr);
};

const cleanStrRecursively = (str) => {
  for (let keyword of blackList) {
    let r = new RegExp(_.unescape(keyword), 'gmi');
    str = str.replace(r, '');
  }
  for (let keyword of blackList) {
    if (str.includes(keyword)) {
      cleanStrRecursively(str);
    }
  }
  return str;
};

// escape special characters for regex
const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/**
 * Escapes special HTML characters in a string to prevent XSS or rendering issues.
 * Converts characters like <, >, " into their corresponding HTML entities.
 *
 * @param str - The input string to be escaped.
 * @returns A string with special HTML characters replaced by their safe entity equivalents.
 *
 * @example
 * escapeHTML('<script>alert("XSS")</script>');
 * // Returns: '&lt;script&gt;alert(&quot;XSS&quot;)&lt;/script&gt;'
 */
const escapeHTML = (str) => {
  if (!str) return '';
  return str.replace(/[<>"]/g, (match) => {
    const escape = {
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
    };
    return escape[match];
  });
};

/**
 * Recursively sanitizes all string values within a nested object or array.
 * Escapes HTML to prevent XSS. Leaves non-strings unchanged.
 *
 * @param {*} input - The value to sanitize (object, array, string, etc.).
 * @returns {*} A deep copy of the sanitized input.
 */
export function sanitizeObjectDeep(input) {
  if (!input || typeof input === 'number' || typeof input === 'boolean' || input === '') {
    return input;
  }

  if (typeof input === 'string') {
    return escapeHTML(input);
  }

  if (Array.isArray(input)) {
    return input.map(sanitizeObjectDeep);
  }

  if (typeof input === 'object') {
    const sanitized = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        sanitized[key] = sanitizeObjectDeep(input[key]);
      }
    }
    return sanitized;
  }

  return input;
}

export { sanitizeString, cleanObj as sanitizeObject, escapeRegExp, escapeHTML };
